import React, { FC } from 'react'
import './update-banner.css'

// COMPONENTS
import Button from '@components/atoms/button'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    open?: boolean

    update(): void
    ignore(): void
}

const UpdateBanner: FC<Props> = (props) => {
    const { className: classProp, open = false, update, ignore, ...divProps } = props
    const className = flatten('update-banner', { open }, classProp)

    return (
        <div className={className} {...divProps}>
            <div className="flex flex-col items-center">
                <p className='text-body' style={{ alignSelf: 'flex-start', justifySelf: 'flex-start', flex: 1 }}>
                    <strong>A new version is available!</strong>
                    <br />
                    Update now for the best experience.
                </p>
                <div className='flex flex-row justify-between w-full'>
                    <Button theme='primary' style={{ marginRight: '1rem', flex: 2 }} onClick={update}>Update</Button>
                    <Button style={{ background: 'transparent', borderWidth: '0px' }} onClick={ignore}>Cancel</Button>
                </div>
            </div>
        </div>
    )
}

export default UpdateBanner
